import rating_1 from "@/assets/images/icons/bond_rating/rating_1.svg";
import rating_2 from "@/assets/images/icons/bond_rating/rating_2.svg";
import rating_3 from "@/assets/images/icons/bond_rating/rating_3.svg";
import rating_4 from "@/assets/images/icons/bond_rating/rating_4.svg";
import rating_5 from "@/assets/images/icons/bond_rating/rating_5.svg";
import rating_6 from "@/assets/images/icons/bond_rating/rating_6.svg";

export const getRatingIcon = (tag?: string | null) => {
  const upperTag = tag?.toUpperCase().trim();
  if (!upperTag) return null;

  if (/\bAAA\b|\bAA[+-]?\b/.test(upperTag)) return rating_1;
  if (/\bA[+-]?\b/.test(upperTag)) return rating_2;
  if (/\bBBB[+-]?\b/.test(upperTag)) return rating_3;
  if (/\bBB[+-]?\b/.test(upperTag)) return rating_4;
  if (/\bB[+-]?\b/.test(upperTag)) return rating_5;
  if (/\bC\b|\bD\b/.test(upperTag)) return rating_6;

  return null;
};
